import { render, staticRenderFns } from "./Chapter_show_2.vue?vue&type=template&id=24d8f4ea&scoped=true&"
import script from "./Chapter_show_2.vue?vue&type=script&lang=js&"
export * from "./Chapter_show_2.vue?vue&type=script&lang=js&"
import style0 from "./Chapter_show_2.vue?vue&type=style&index=0&id=24d8f4ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d8f4ea",
  null
  
)

export default component.exports